import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { DocumentExpiryPage } from '../../../features/hr/documents-page'
import { documentSearchSchema } from '../../../features/hr/search'

export const Route = createFileRoute('/_app/hr/documents')({
  staticData: { crumb: 'hrDocuments' },
  validateSearch: documentSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'employees.read'),
  component: DocumentExpiryPage,
})
